import * as types from './mutation_types'
import * as utils from '../utils'
import Vue from 'vue'
const objectPath = require('object-path')

export default {
	[types.SET_USER] (state, user) {
		state.user = user
	},

	[types.SET_BASE_SETTING] (state, setting) {
		state.agents = objectPath.get(setting, 'agents', [])
		delete setting.agents

		state.accountSetting = utils.cloneDeep(setting)
	},

	[types.SET_SETTING] (state, setting) {
		const urlLogo = objectPath.get(setting, 'account.logo_url', '')
		if (urlLogo) state.defaultAvatar = urlLogo

		const dateFormatDefault = utils.cloneDeep(state.dateFormat)
		state.dateFormat = objectPath.get(setting, 'account.date_format', dateFormatDefault)

		state.user = utils.cloneDeep(setting.user)
		delete setting.user

		state.account = utils.cloneDeep(setting.account)
		delete setting.account

		state.agents = objectPath.get(setting, 'account_setting.agents', [])
		delete setting.account_setting.agents

		state.accountSetting = utils.cloneDeep(setting.account_setting)
		delete setting.account_setting

		state.widgetSetting = utils.cloneDeep(setting)
	},

	[types.SET_CONVO_LIST] (state, conversations) {
		state.conversations = conversations
	},

	[types.DELETE_CONVO_LIST] (state) {
		state.conversations = []
		state.convoListEnd = false
	},

	[types.ADD_CONVO] (state, { convo, position = 'begin' }) {
		const found = utils.find(state.conversations, item => item.id === convo.id)
		if (found) {
			return true
		}

		if (position === 'begin') {
			state.conversations.unshift(convo)
		} else {
			state.conversations.push(convo)
		}

		Vue.set(state.convoEvents, convo.id, [])
	},

	[types.UPDATE_USER] (state, data) {
		const user = Object.assign({}, utils.cloneDeep(state.user), utils.cloneDeep(data))
		if (!utils.isEmpty(data.attributes)) {
			const oldAttributes = objectPath.get(state.user, 'attributes', [])
			user.attributes = utils.unionBy(oldAttributes, utils.cloneDeep(data.attributes), 'key')
		}
		Vue.set(state, 'user', user)
	},

	[types.SET_ORIGIN_VIEWPORT] (state, data) {
		state.originViewport = utils.cloneDeep(data)
	},

	[types.SET_MODIFIED_VIEWPORT] (state, data) {
		state.modifiedViewport = utils.cloneDeep(data)
	},

	[types.SET_VIEWPORT] (state, data) {
		state.viewport = utils.cloneDeep(data)
	},

	[types.SET_WINDOW_MODE] (state, windowMode) {
		state.windowMode = windowMode
	},

	[types.SET_POSITION] (state, position) {
		state.position = position
	},

	[types.SET_NOW] (state, now) {
		state.now = now
	},

	[types.UPDATE_CONVO] (state, { convoId, convo }) {
		state.conversations.forEach((v, k) => {
			if (v.id === convoId) {
				Vue.set(state.conversations, k, convo)
			}
		})
	},

	[types.ADD_EVENT] (state, { convoId, event, position = 'end' }) {
		let events = state.convoEvents[convoId] || []

		const found = utils.find(events, item => item.id === event.id)
		if (found) {
			return true
		}

		if (position === 'end') {
			events.push(event)
		} else {
			events.unshift(event)
		}

		Vue.set(state.convoEvents, convoId, events)
	},

	[types.ADD_EVENTS] (state, { convoId, events, position = 'end' }) {
		const addEvents = events.slice(0)
		if (position === 'begin') addEvents.reverse()

		const beforeEvents = state.convoEvents[convoId] || []
		const afterEvents = beforeEvents.slice(0)

		utils.find(addEvents, event => {
			const found = utils.find(beforeEvents, item => item.id === event.id)
			if (found) {
				return false
			}

			if (position === 'end') {
				afterEvents.push(event)
			} else {
				afterEvents.unshift(event)
			}
		})

		Vue.set(state.convoEvents, convoId, afterEvents)
	},

	[types.UPDATE_EVENT] (state, { convoId, event }) {
		let events = state.convoEvents[convoId] || []

		events.forEach((item, i) => {
			if (item.id === event.id) {
				Vue.set(state.convoEvents[convoId], i, event)
			}
		})
	},

	[types.UPDATE_EVENT_CAPTURE_LEAD] (state, { convoId, eventId, fields }) {
		let events = state.convoEvents[convoId] || []
		events.forEach((item, i) => {
			if (item.id === eventId) {
				Vue.set(state.convoEvents[convoId][i].data.message.attachments[0].form, 'fields', fields)
			}
		})
	},

	[types.UPDATE_PONG_MESSAGE] (state, { convoId, eventId, pongs }) {
		const events = state.convoEvents[convoId] || []

		const event = utils.find(events, item => item.id === eventId)
		if (!event || !event.id) {
			return false
		}

		const oldPongs = objectPath.get(event, 'data.message.pongs', [])
		for (const pong of pongs) {
			let found = false
			oldPongs.forEach(p => {
				if (p.type === pong.type && p.member_id === pong.member_id) found = true
			})
			if (!found) {
				objectPath.push(event, 'data.message.pongs', pong)
			}
		}

		for (var k in events) {
			if (events[k].id === eventId) {
				events[k] = event
			}
		}
		let index = utils.findIndex(state.conversations, conversation => conversation.id === convoId)
		if (index > -1) Vue.set(state.conversations[index], 'actived', +new Date() * 1000000)
		Vue.set(state.convoEvents, convoId, events)
	},

	[types.SET_USER_READY] (state, ready) {
		state.userReady = !!ready
	},

	[types.SET_SETTING_READY] (state, ready) {
		state.settingReady = !!ready
	},

	[types.SET_WS_READY] (state, ready) {
		state.wsReady = !!ready
	},

	[types.SET_CSS_READY] (state, ready) {
		state.cssReady = !!ready
	},

	[types.SET_LANGUAGE_READY] (state, ready) {
		state.languageReady = !!ready
	},

	[types.SET_CONVO_LIST_READY] (state, ready) {
		state.convoListReady = !!ready
	},

	[types.SET_CONVO_LIST_END] (state, ended) {
		state.convoListEnd = ended
	},

	[types.SET_LAST_CONVO_ID] (state, convoId) {
		state.lastConvoId = convoId
	},

	[types.SET_EVENT_ANCHORS] (state, { convoId, anchor }) {
		Vue.set(state.eventAnchors, convoId, anchor)
	},

	[types.SET_EVENT_ENDS] (state, { convoId, ended }) {
		Vue.set(state.eventEnds, convoId, ended)
	},

	[types.SET_ALL_READY] (state, ready) {
		state.allReady = !!ready
	},

	[types.SET_BASE_SETTING_READY] (state, ready) {
		state.baseSettingReady = !!ready
	},

	[types.SET_ACCOUNT_ID] (state, accountId) {
		state.accountId = accountId
	},

	[types.SET_USER_ID] (state, userId) {
		state.userId = userId
	},

	[types.SET_USER_MASK] (state, userMask) {
		state.userMask = userMask
	},

	[types.SET_LANGUAGE_CODE] (state, code) {
		state.languageCode = code
	},

	[types.RESET] (state) {
		const initial = utils.cloneDeep(state.initial)
		Object.keys(initial).forEach(key => {
			state[key] = initial[key]
		})
	},

	[types.SET_GEOIP] (state, geoIP) {
		Vue.set(state, 'geoIP', geoIP)
	},

	[types.SET_THEME_COLOR] (state, color) {
		state.themeColor = color
	},

	[types.SET_FCM_TOKEN] (state, token) {
		Vue.set(state, 'fcmToken', token)
	},

	[types.SET_CUSTOM_SCREEN] (state, { id, screenComponent }) {
		Vue.set(state.customScreens, id, screenComponent)
	},

	[types.SET_LAST_SCREEN_ID] (state, screenId) {
		state.lastScreenId = screenId
	},

	[types.SET_OFFLINE] (state, isOffline) {
		state.isOffline = !!isOffline
	},

	[types.SET_HOVERING] (state, isHovering) {
		state.isHovering = !!isHovering
	},

	[types.SET_FOCUSMESSAGEINPUT] (state, focusMessageInput) {
		state.focusMessageInput = !!focusMessageInput
	},

	[types.SET_CONNECTION_ID] (state, id) {
		state.connectionId = id
	},

	[types.SET_DEVICE] (state, device) {
		Vue.set(state, 'device', device)
	},

	[types.SET_DOM_READY] (state, ready) {
		state.domReady = !!ready
	},

	[types.DELETE_EVENTS] (state, { convoId }) {
		Vue.delete(state.convoEvents, convoId)
	},
	[types.SET_PARENT_HREF] (state, href) {
		state.parent_href = href
	},
	[types.SET_PARENT_TITLE] (state, title) {
		state.parent_title = title
	},
	[types.HAS_CUSTOM_TITLE] (state, status) {
		state.hasCustomTitle = status
	},
}
